import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NzTableQueryParams, NzTableModule } from 'ng-zorro-antd/table';
import { map, Observable, switchMap } from 'rxjs';
import { ReleaseService } from 'src/app/services/release.service';
import { ReleaseData, ReleasesResponse } from 'src/app/types/release.type';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { AsyncPipe } from '@angular/common';
@Component({
  selector: 'app-release',
  templateUrl: './release.component.html',
  styleUrls: ['./release.component.scss'],
  imports: [NzTableModule, AsyncPipe, RouterLink, NzPageHeaderModule],
})
export class ReleaseComponent {
  private releaseService = inject(ReleaseService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  releases: ReleaseData[] = [];
  loading = signal(true);
  pageSize = 10;
  pageNumber = 1;
  totalReleases = 0;
  productId = 0;
  isSendEmailNotifications = true;

  queryParams$ = this.getQueryParams();

  ngOnInit(): void {
    const url = this.router.url;
    const match = url.match(/\/product\/(\d+)/);
    this.productId = match ? Number(match[1]) : 0;
  }

  getQueryParams(): Observable<ReleasesResponse> {
    return this.activatedRoute.queryParamMap.pipe(
      switchMap((params) => {
        const page = Number(params.get('page'));
        const pageSize = Number(params.get('pageSize'));

        if (!!pageSize) this.pageSize = Number(params.get('pageSize'));

        return this.getReleases(isNaN(page) || page < 1 ? 1 : page);
      }),
    );
  }

  getReleases(pageNumber: number): Observable<ReleasesResponse> {
    this.pageNumber = pageNumber;

    return this.releaseService
      .releases({
        pageNumber,
        pageSize: this.pageSize,
        productId: !!this.productId ? this.productId : (null as any),
      })
      .pipe(
        map(({ releases, count }) => {
          this.totalReleases = count;
          this.releases = releases;

          return { releases, count };
        }),
      );
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageIndex } = params;

    if (this.pageNumber === pageIndex && this.pageSize === params.pageSize)
      return;

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: params.pageSize !== this.pageSize ? 1 : pageIndex,
        pageSize: params.pageSize,
      },
      queryParamsHandling: 'merge',
    });
  }

  getPathToDetails(releaseId: number): string | any[] | null | undefined {
    if (!!this.productId)
      return [`/product`, `${this.productId}`, `release`, `${releaseId}`];

    return [`/releases`, `${releaseId}`, `details`];
  }
}
